import RefinementError, { type RefinementError as RefinementErrorCode } from '$/_const/trip/RefinementError.ts';
import { RefinementRequestError } from '@/api/itineraries/invokeRefinement.ts';
import refineDayErrorKey from '@/utils/trip/refineDayErrorKey.ts';

export type RefineDayError = {
  day: number;
  error: string;
  code?: RefinementErrorCode;
  status?: number;
  message?: string;
};

export type DayRefinementFailure = {
  dayError: RefineDayError;
  opensPlans: boolean;
  toastKey: string | null;
  isReported: boolean;
};

const REFINEMENT_LIMIT_MESSAGE = 'limit';

const describeDayRefinementFailure = (day: number, error: unknown): DayRefinementFailure => {
  const code = error instanceof RefinementRequestError ? error.code : undefined;
  const status = error instanceof RefinementRequestError ? error.status : undefined;
  const dayError: RefineDayError = {
    day,
    error: error instanceof Error ? error.message : 'An unknown error occurred while refining day',
    code,
    status,
  };

  if (error instanceof Error && error.message === REFINEMENT_LIMIT_MESSAGE) {
    return { dayError, opensPlans: true, toastKey: null, isReported: false };
  }

  return {
    dayError,
    opensPlans: false,
    toastKey: refineDayErrorKey(code, status),
    isReported: code !== RefinementError.NO_MATERIAL_CHANGE,
  };
};

export default describeDayRefinementFailure;
